import React, { memo, useEffect, useState } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { ImgWrap } from 'pubBiz';

const defaultProps = {
  data: [],
  containerStyle: {},
  multipleMargin: '0.12rem',
  onPress: null
};

const propTypes = {
  width: PropTypes.any.isRequired, // 宽度 必传
  data: PropTypes.array, // 数据源
  containerStyle: PropTypes.object, // 容器样式
  multipleMargin: PropTypes.number, // 间隙
  onPress: PropTypes.func // 点击事件
};

const ThreeCell = memo((props) => {
  const {
    width: cellWidth, // any 宽度
    data, // Array 数据源
    containerStyle, // Object 容器样式
    multipleMargin, // Number 间隙宽度
    onPress // Function 点击事件
  } = props;
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    setSize({
      width: `calc((${cellWidth} - 2 * ${multipleMargin}) / 3)`,
      height: '3.8rem'
    });
  }, [cellWidth, multipleMargin]);

  const renderItem = (item, index) => {
    const { imgInfo } = item;
    const { imgUrl, width, height } = imgInfo;

    let imgWidth = size.width;
    let imgHeight = `calc(${imgWidth} * ${height} / ${width})`;

    return (
      <Flex key={`ThreeCell${index}`} onClick={() => onPress && onPress(item)}>
        <ImgWrap src={imgUrl || ''} mode={'cover'} w={imgWidth} h={imgHeight} />
      </Flex>
    );
  };

  return (
    <Flex direction="row" align="center" justify="between" wrap="wrap" style={containerStyle}>
      {data.map((item, index) => renderItem(item, index))}
    </Flex>
  );
});

ThreeCell.defaultProps = defaultProps;
ThreeCell.propTypes = propTypes;

export default ThreeCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/ThreeCell/index.js